// extracted by mini-css-extract-plugin
export var closeButton = "_j0-2";
export var closeButtonIcon = "_j0-3";
export var lightboxContent = "_j0-1";
export var lightboxOverlay = "_j0-0";